import { connect } from 'react-redux';
import withState from 'recompose/withState';
import withHandlers from 'recompose/withHandlers';
import compose from 'recompose/compose';
import History from './History';
import {
  getPayoutReportHistoryFromRaw,
  getPayoutReportPagination,
  getPayoutReportSummaryFromRaw,
} from '../../selectors';
import { fetchPayoutsHistoryMore } from '../../actions';
import * as authSelectors from '../../../../auth/selectors';

const mapStateToProps = (state) => {
  const summary = getPayoutReportSummaryFromRaw(state);
  const history = getPayoutReportHistoryFromRaw(state);
  const pagination = getPayoutReportPagination(state);

  return {
    summary: Array.isArray(summary) ? summary : [],
    history,
    pagination,
    shopId: authSelectors.getShop(state),
    isSingleShopOtpBrand: authSelectors.isSingleShopOtpBrand(state),
    brandSingleShopId: authSelectors.getBrandSingleShopId(state),
  };
};

const mapDispatchToProps = {
  fetchPayoutsHistoryMore,
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('showHistory', 'setShowHistory', false),
  withState('expanded', 'setExpanded', {}),
  withState('loading', 'setLoading', false),
  withHandlers({
    loadMore: (props) => async () => {
      if (props.loading || !props.pagination.hasMore) return;
      props.setLoading(true);
      const shopId = props.isSingleShopOtpBrand ? props.brandSingleShopId : props.shopId;
      await props.fetchPayoutsHistoryMore(shopId, props.pagination.skip);
      props.setLoading(false);
    },
  })
);

export default enhance(History);
